<nav class="pagination is-centered" role="navigation" aria-label="pagination">


  <ul class="pagination-list">
    <li>
      <button class="pagination-previous" aria-label="Go To Previous Page"
              [attr.aria-disabled]="current === 1"
              [disabled]="current === 1"
              (click)="onPrevious()"><<</button>
    </li>
    <li *ngFor="let page of pages;">
      <a class="pagination-link"
        [attr.aria-current]="page === current ? 'page' : null"
        [attr.aria-label]="page === current ? 'Current Page, Page ' + page : 'Go to Page ' + page"
        [class.is-current]="page === current"
        tabindex="0"
        (click)="onGoTo(page)"
        (keyup.enter)="onGoTo(page)">
        {{ page }}</a
      >
    </li>
    <li>
      <button class="pagination-next"     aria-label="Go To Next Page"
              [attr.aria-disabled]="current === total"
              [disabled]="current === total"
              (click)="onNext()">>></button>
    </li>
  </ul>
</nav>
